import axios from "axios";
import { ElMessage } from "element-plus";
import router from "@/router"; // 导入路由实例

// 创建基础axios实例
const createService = (baseURL = "/api") => {
  const service = axios.create({
    baseURL,
  });

  // 请求拦截器
  service.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  service.interceptors.response.use(
    (response) => {
      const { data, config, status } = response;
      let { errcode, errmsg } = data;
      console.log(status);
      if (errcode === 1 ) {
        // 未登录，跳转到登录页
        router.push("/login");
        // 清除本地token
        localStorage.removeItem("userInfo");
        return Promise.reject(new Error("登录状态已失效"));
      }
      if (errcode === -1) {
        ElMessage.error(errmsg || `Whoops! 服务器异常`);
        return Promise.reject({ url: config.url, data });
      } else {
        return data;
      }
    },
    (error) => {
      if (error.response) {
        const { status } = error.response;
        let message = "请求失败";
        console.log(status);

        if (status === 401) {
          message = "登录状态已失效";
          router.push("/login");
          // 清除本地token
          localStorage.removeItem("userInfo");
          return Promise.reject(new Error("登录状态已失效"));
        } else if (status === 404) {
          message = "请求的资源不存在";
        } else if (status === 500) {
          message = "服务器内部错误";
        } else if (status === 502) {
          message = "网关错误";
        } else {
          message = `请求错误: ${status}`;
        }
        ElMessage.error(message);
      } else {
        ElMessage.error("网络连接异常，请检查网络");
      }
      return new Promise(() => {});
    }
  );

  return service;
};

// 创建不同分组的API服务实例
export const apiService = createService("/api"); // 默认API服务
export const ssoService = createService("/api/sso"); // SSO分组API服务
export const reportService = createService("/api/report-system"); // 报表系统分组API服务
export const userManagementService = createService("/api/user-management"); // 用户管理分组API服务

// 导出默认服务（保持向后兼容）
export default apiService;
